import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { useNotificationsSettings } from "@domain/notification/hooks";
import {
	allNotificationSettingsCategories,
	NotificationCategory,
	NotificationMode,
} from "@domain/notification/notification";
import { Primary } from "@ui/components/containers/primary";
import { Toggle } from "@ui/components/inputs/toggle";

interface NotificationSettingsProps extends React.HTMLAttributes<HTMLDivElement> {
	onSettingsChange: (item: NotificationCategory, mode: NotificationMode, enabled: boolean) => Promise<void>;
}

export const NotificationSettings: React.FC<NotificationSettingsProps> = ({ onSettingsChange, ...htmlProps }) => {
	const { result: settings } = useNotificationsSettings();

	return (
		<Container {...htmlProps}>
			<Header>
				<tr>
					<th>{I18n.t("settings.notifications.header.type")}</th>
					<th>{I18n.t("settings.notifications.header.email")}</th>
					<th>{I18n.t("settings.notifications.header.app_notification")}</th>
				</tr>
			</Header>
			<Body>
				{allNotificationSettingsCategories.map((item) => (
					<tr key={item}>
						<td>
							<Primary>
								<b>{I18n.t(`setting.notifications.content.${item.toLowerCase()}.title`)}</b>
							</Primary>
							<Description>{I18n.t(`setting.notifications.content.${item.toLowerCase()}.description`)}</Description>
						</td>
						<td>
							<Toggle
								disabled={item === "SYSTEM"}
								toggled={!!settings.find(({ category, mode }) => category === item && mode === "EMAIL")}
								onChange={(enabled) => onSettingsChange(item, "EMAIL", enabled)}
							/>
						</td>
						<td>
							<Toggle
								disabled={item === "SYSTEM"}
								toggled={!!settings.find(({ category, mode }) => category === item && mode === "INAPP")}
								onChange={(enabled) => onSettingsChange(item, "INAPP", enabled)}
							/>
						</td>
					</tr>
				))}
			</Body>
		</Container>
	);
};

const Container = styled.table`
	width: 100%;
`;

const Header = styled.thead`
	th {
		${({ theme }) => theme.textStyles.tertiary};
		color: ${({ theme }) => theme.colors.textSecondary};
		text-align: left;
		padding-bottom: 24px;
	}
	tr th:not(:first-child) {
		width: 110px;
	}
`;

const Body = styled.tbody`
	td {
		padding-bottom: 20px;
		padding-right: 30px;
	}
`;

const Description = styled.div`
	color: ${({ theme }) => theme.colors.textTertiary};
	font-size: 0.8125rem;
	margin-top: 5px;
`;
